import { FC, HTMLAttributes, PropsWithChildren } from "react";
import styled from "styled-components";

type Props = PropsWithChildren<
  HTMLAttributes<HTMLDivElement> & {
    label: string;
    color: string;
    step: string;
  }
>;
const StepBlock: FC<Props> = ({ label, color, step, children, ...props }) => {
  return (
    <Root $color={color} {...props}>
      <Headline $color={color}>
        <StepImage src={`/image/lp/corphurusato/deduction_flow/step/step_${step}.png`} />
        <span>{label}</span>
      </Headline>
      <Content>{children}</Content>
    </Root>
  );
};
export default StepBlock;

const Root = styled.div<{ $color: string }>`
  border: solid 2px ${({ $color }) => $color};
`;
const Headline = styled.div<{ $color: string }>`
  position: relative;
  background-color: ${({ $color }) => $color};
  font-family: sans-serif;
  font-weight: bold;
  font-size: 1.2em;
  color: white;
  text-align: center;
  padding: calc(0.5em - 2px) 0 0.5em;
`;

const StepImage = styled.img`
  position: absolute;
  left: max(0px, calc(50% - 185px));

  @media screen and (max-width: 960px) {
    width: 44px;
    height: 44px;
    top: -16px;
  }
  
  @media screen and (min-width: 961px) {
    width: 44px;
    height: 44px;
    top: -16px;
  }
`;

const Content = styled.div`
  padding: 15px 10px;
`;
